export function drawPoint(ctx, x, y, color = 'red', size = 3) {
  ctx.beginPath()
  ctx.arc(x, y, size, 0, 2 * Math.PI)
  ctx.fillStyle = color
  ctx.fill()
}

export function drawLine(ctx, x1, y1, x2, y2, color = 'red') {
  ctx.beginPath()
  ctx.moveTo(x1, y1)
  ctx.lineTo(x2, y2)
  ctx.strokeStyle = color
  ctx.stroke()
}

export function drawX (ctx, point, size, color) {
  const halfSize = size / 2;

  ctx.strokeStyle = color
  ctx.beginPath();
  ctx.moveTo(point.x - halfSize, point.y - halfSize);
  ctx.lineTo(point.x + halfSize, point.y + halfSize);
  ctx.moveTo(point.x + halfSize, point.y - halfSize);
  ctx.lineTo(point.x - halfSize, point.y + halfSize);
  ctx.stroke();
}

export function getRandomHexColor() {
  const hexChars = '0123456789ABCDEF'
  let color = '#'
  for (let i = 0; i < 6; i++) {
    color += hexChars[Math.floor(Math.random() * 16)]
  }
  return color
}
